import { render, staticRenderFns } from "./SampleButtons.vue?vue&type=template&id=089dab2e&lang=html"
import script from "./SampleButtons.vue?vue&type=script&lang=js"
export * from "./SampleButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports